import LoginPage from '../vnext/auth/LoginPage';

export default LoginPage;
